<template>
      <div class="showDays">
        <div v-for="day in days" :key="day" class="cursor-pointer" :class="{'active':activeDay === day}" v-on:click="changeActiveDay(day)">
          <span class="day">{{getFormattedDay(day, "dddd", true)}}</span><br/>
          <span class="date">{{getFormattedDay(day, "MMM DD", true)}}</span>
        </div>
      </div>
</template>
<script>
import { formatDate } from '../../helpers';
export default {
  name: 'app',
  props: {
    days: Array,
    activeDay: String,
    view: String
  },
  components: {},
  methods: {
    changeActiveDay: function (newVal) {
      this.$emit('activeDaySelected', newVal)
    },
    getFormattedDay: function(day, format, toUpperCase){
      return formatDate(day, format, toUpperCase)
    }
  }
}

</script>
